import type { Client, Status } from "@/types";

export function getClientStatusFromLicense(licenseStatus: string, leaseDays: number): Status {
  if (licenseStatus === "active") {
    return leaseDays === 0 || leaseDays > 7 ? "active" : "warning";
  }
  return "blocked";
}

export function getLicensePeriodLabel(expiresAt: string, leaseDays: number) {
  return expiresAt ? `${leaseDays}д` : "Бессрочно";
}

export function getClientPaymentFromLicense(licenseStatus: string): Client["payment"] {
  if (licenseStatus === "active") return "Оплачено";
  if (licenseStatus === "none") return "Ожидает";
  return "Просрочено";
}
